<template>
<div>
	<div class="form-box">
		<div class="back-for-pc">
			<i class="fa fa-chevron-left" v-show="pcDisp && !knowledgeIndexDisp" @click="toggle('index')"></i>
		</div>
		<input id="name" class="form-control dash-border-color-skin" :placeholder="labels[nowLang].searchPlaceHolder" autocomplete="off" spellcheck="false" autocorrect="off" tabindex="1"v-model="subject">

		<div class="knowledge-btn dash-bg-color-skin cursor-pointer" @click="callSearch()"><a>{{ labels[nowLang].search }}</a></div>
		<div class="clearfix"></div>
	</div>	
</div>
</template>

<script>
export default {
  name: 'knowledge-search',
  data () {
    return {
      subject: this.value
    }
  },
  watch: {
    value () {
      this.subject = this.value
    },
    subject () {
      this.$emit('input', this.subject)
    }
  },
  props: [ 'toggle', 'pcDisp', 'knowledgeIndexDisp', 'value', 'nowLang', 'labels' ],
  methods: {
    callSearch () {
      this.$emit('enableTriggerResetBool')
      this.toggle('index')
    }
  }
}
</script>


// WEBPACK FOOTER //
// search.vue?05f6175e